export default __webpack_public_path__ + "static/media/deleteIcon.c2c8b165.svg";